import React, { useEffect } from 'react';
import { QuizPage } from '../components/QuizPage';
export function Capacity({
  onAnswer
}: {
  onAnswer: (ans: string, dq: boolean) => void;
}) {
  useEffect(() => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'ViewContent');
    }
  }, []);
  return <QuizPage stepNumber={1} question="How many new patients a week can you handle?" options={[{
    label: '1-5'
  }, {
    label: '5-11'
  }, {
    label: '12-20'
  }, {
    label: '25+'
  }]} onSelect={opt => onAnswer(opt.label, !!opt.isDq)} data-id="element-147" />;
}